import { actions } from './services';

const getInitialState = () => {
  return {
    tempFiles: [],
    foodBooklet: {
      categories: [],
      vetSupplements: [],
      futalisSupplements: []
    },
    error: {
      message: '',
      isSet: false
    },
    currentClient: {
      id: 0,
      isVet: 0,
      name: ''
    },
    s_illness_list: [],
    pet: {
      s_illnesses: [],
      petFiles: [],
    },
  };
};

//by default => initial state
const state = getInitialState();

const mutations = {
  setClient: (state, payload) => {
    state.currentClient = payload;
  },
  setError: (state, payload) => {
    state.error = {
      isSet: true,
      message: payload
    };
  },
  clearError: state => {
    state.error = getInitialState().error;
  },
  setFoodBookletData: (state, payload) => {
    state.foodBooklet = {
      ...state.foodBooklet,
      categories: payload.categories,
      vetSupplements: payload.vetSupplements,
      futalisSupplements: payload.futalisSupplements
    };
  },
  setVetSupplements: (state, payload) => {
    state.foodBooklet = {
      ...state.foodBooklet,
      vetSupplements: payload
    };
  },
  removeVetSupplements: (state, payload) => {
    state.foodBooklet = {
      ...state.foodBooklet,
      vetSupplements: state.foodBooklet.vetSupplements.filter(
        v => v.id !== payload
      )
    };
  },
  setSpecialIllnesses: (state, payload) => {
    state.s_illness_list = payload;
  },
  setTempFiles: (state, payload) => {
    state.tempFiles = payload
  },
  setFiles: (state, payload) => {
    state.pet.petFiles = payload
  },
  setPet: (state, payload) => {
    state.pet = payload;
  }
};
const getters = {
  s_illnessesData: (state) => state.s_illness_list
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
